import getAccountNumber from "./getAccountNumber";
import getUserId from "./getUserId";
import getBranchCode from "./getBranchCode";

const getUserCacheKey = () => {
  const accountNumber = getAccountNumber();
  const userId = getUserId();
  const branchCode = getBranchCode();

  if (accountNumber && userId) {
    return `A${accountNumber}-U${userId}`;
  }

  if (userId) {
    return `U${userId}`;
  }

  if (branchCode) {
    return `B${branchCode}`;
  }

  return null;
};

export default getUserCacheKey;
